import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["loginRequestSent", "providerService", "user", "servicePlans", "accessToken", "redirectBack", "post", "resources", "requestLogin", "createSubscriptionOrder", "createPlanProspect", "createServiceProspect", "getPlansForAsset", "signup", "planWaitlistIds", "currentUser"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { getServicePlans as _getServicePlans, getUserSubscriptions as _getUserSubscriptions, AssetResourceType } from '../interfaces';
import { getPlansForAsset as getPlansForAssetAction, requestLogin as requestLoginAction, signup as signupAction, createPlanProspect as createPlanProspectAction, createServiceProspect as createServiceProspectAction, createSubscriptionOrder as createSubscriptionOrderAction } from '../state/actions';
import { SubscriptionPlanListPage, TWSubscriptionPlanList } from '../components/TWSubscriptionPlanList';
import { useRouter } from 'next/router';
import { getQuery } from '../utils/helpers';
import cookie from 'js-cookie';
import SignupFlow from '../components/SignupFlow';
import { identifyLoggedInUser, // eslint-disable-next-line @typescript-eslint/no-unused-vars
serviceLeadCreated } from '../utils/segmentAnalytics';
import { CookieName, servicePageTabs } from '../utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PlanContainer = function PlanContainer(_ref) {
  var _providerService$prov2;

  var loginRequestSent = _ref.loginRequestSent,
      providerService = _ref.providerService,
      user = _ref.user,
      servicePlans = _ref.servicePlans,
      accessToken = _ref.accessToken,
      redirectBack = _ref.redirectBack,
      post = _ref.post,
      resources = _ref.resources,
      requestLogin = _ref.requestLogin,
      createSubscriptionOrder = _ref.createSubscriptionOrder,
      createPlanProspect = _ref.createPlanProspect,
      createServiceProspect = _ref.createServiceProspect,
      getPlansForAsset = _ref.getPlansForAsset,
      signup = _ref.signup,
      planWaitlistIds = _ref.planWaitlistIds,
      currentUser = _ref.currentUser,
      props = _objectWithoutProperties(_ref, _excluded);

  var router = useRouter();

  var _useState = useState(null),
      authStep = _useState[0],
      setAuthStep = _useState[1];

  var _useState2 = useState(''),
      email = _useState2[0],
      setEmail = _useState2[1];

  var _useState3 = useState(''),
      activePlanId = _useState3[0],
      setActivePlanId = _useState3[1];

  var _useState4 = useState(),
      redirect = _useState4[0],
      setRedirect = _useState4[1];

  var asPath = router.asPath;
  var redirectURL = redirectBack ? encodeURIComponent(asPath) : '';
  var planId = getQuery(router.query.planId);
  var forPosts = !!(post !== null && post !== void 0 && post.id);
  var plans = servicePlans;

  if (forPosts) {
    var _resources$post$id;

    var plansForPost = (((_resources$post$id = resources[post.id]) === null || _resources$post$id === void 0 ? void 0 : _resources$post$id.plans) || []).map(function (plan) {
      return plan.id;
    });
    plans = servicePlans.filter(function (plan) {
      return plansForPost.includes(plan.id);
    });
  } // If the user just logged in from email link and wants to get a plan...


  var planIdProcessed = useRef();
  useEffect(function () {
    var _providerService$prov;

    if (!(providerService !== null && providerService !== void 0 && (_providerService$prov = providerService.provider) !== null && _providerService$prov !== void 0 && _providerService$prov.slug)) return;

    var _servicePlans$filter = servicePlans.filter(function (p) {
      return p.id === planId;
    }),
        _servicePlans$filter2 = _slicedToArray(_servicePlans$filter, 1),
        plan = _servicePlans$filter2[0];

    if (!plan || planId === planIdProcessed.current) {
      return;
    }

    if (accessToken && user !== null && user !== void 0 && user.id) {
      planIdProcessed.current = planId;
      identifyLoggedInUser(user);

      if (!plan.waitlist) {
        createSubscriptionOrder(planId, redirectURL);
        return;
      }

      if (planWaitlistIds.includes(planId)) return; // already on the waitlist
      // createPlanProspect ensures both service+plan prospects exist, and can only be called by authenticated user

      createPlanProspect({
        planId: plan.id,
        serviceId: plan.providerService.id
      }).then(function (_ref2) {
        var planProspect = _ref2.planProspect;
        // waitlist -> survey
        if (planProspect) setRedirect("/".concat(providerService.provider.slug, "/").concat(providerService.slug, "/plans/").concat(plan.id, "/survey?planProspectId=").concat(planProspect.id));
      });
    }
  }, [servicePlans, planId, user === null || user === void 0 ? void 0 : user.id, providerService === null || providerService === void 0 ? void 0 : (_providerService$prov2 = providerService.provider) === null || _providerService$prov2 === void 0 ? void 0 : _providerService$prov2.slug]);
  useEffect(function () {
    if (loginRequestSent) {
      setAuthStep('confirm-email-dialog');
    }
  }, [loginRequestSent]);
  useEffect(function () {
    props.getServicePlans(providerService.id);
  }, [providerService.id]);
  useEffect(function () {
    if (accessToken && user !== null && user !== void 0 && user.id) {
      props.getUserSubscriptions(user === null || user === void 0 ? void 0 : user.id);
    }
  }, [accessToken, user === null || user === void 0 ? void 0 : user.id]);
  useEffect(function () {
    if (post !== null && post !== void 0 && post.id && providerService !== null && providerService !== void 0 && providerService.id) {
      getPlansForAsset({
        resourceId: post.id,
        resourceType: AssetResourceType.POST,
        serviceId: providerService.id,
        skipFilterForProvider: forPosts
      });
    }
  }, [post === null || post === void 0 ? void 0 : post.id, providerService === null || providerService === void 0 ? void 0 : providerService.id]);
  useEffect(function () {
    if (!redirect || router.pathname === redirect) return;
    router.push(redirect);
  });

  var planSelectHandler = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(plan) {
      var _yield$createPlanPros, planProspect;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(accessToken && user !== null && user !== void 0 && user.id)) {
                _context.next = 10;
                break;
              }

              if (!plan.waitlist) {
                _context.next = 8;
                break;
              }

              _context.next = 4;
              return createPlanProspect({
                planId: plan.id,
                serviceId: plan.providerService.id
              });

            case 4:
              _yield$createPlanPros = _context.sent;
              planProspect = _yield$createPlanPros.planProspect;
              // waitlist -> survey
              if (planProspect) setRedirect("/".concat(providerService.provider.slug, "/").concat(providerService.slug, "/plans/").concat(plan.id, "/survey?planProspectId=").concat(planProspect.id));
              return _context.abrupt("return");

            case 8:
              createSubscriptionOrder(plan.id, redirectURL);
              return _context.abrupt("return");

            case 10:
              // Not logged in
              setActivePlanId(plan.id);
              setAuthStep('login');

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function planSelectHandler(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var onLoginFormSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formData) {
      var _response$data;

      var redirectPath, response, _servicePlans$filter3, _servicePlans$filter4, plan;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setEmail(formData.email);
              redirectPath = "".concat(window.location.origin + window.location.pathname) + "?planId=".concat(activePlanId).concat(encodeURIComponent('&'), "tab=").concat(servicePageTabs.subscriptionPlans);
              _context2.next = 4;
              return requestLogin(_objectSpread(_objectSpread({}, formData), {}, {
                redirect: redirectPath
              }));

            case 4:
              response = _context2.sent;

              if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status) !== 401)) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return");

            case 7:
              if (!activePlanId) {
                _context2.next = 12;
                break;
              }

              _servicePlans$filter3 = servicePlans.filter(function (p) {
                return p.id === activePlanId;
              }), _servicePlans$filter4 = _slicedToArray(_servicePlans$filter3, 1), plan = _servicePlans$filter4[0];

              if (!(plan !== null && plan !== void 0 && plan.waitlist)) {
                _context2.next = 12;
                break;
              }

              // Plan waitlist: the desired signup flow is the newsletter flow, NOT the full signup flow.
              // It's also important that email content, plus welcome email / email campaign is same as ServiceProspect flow.
              // So here we do NOT create a PlanProspect directly; we create a ServiceProspect and get
              // redirected back to this page, where we then create the PlanProspect & push to survey.
              // Yes, this is a wonky flow. The hope is that all of this will be refactored away w/ ServiceMembers
              createServiceProspect({
                email: formData.email,
                serviceId: providerService.id,
                redirect: redirectPath,
                emailTemplate: 'service-prospect-verification-email-waitlist',
                emailSubject: 'Complete your waitlist signup'
              }).then(function (prospect) {
                return prospect && serviceLeadCreated({
                  providerService: providerService,
                  currentUser: currentUser
                });
              });
              return _context2.abrupt("return");

            case 12:
              setAuthStep('enter-email');

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onLoginFormSubmit(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var onSignupFormSubmit = function onSignupFormSubmit(formData) {
    setEmail(formData.email);
    var redirectPath = "".concat(encodeURIComponent(window.location.origin + window.location.pathname), "?") + "planId=".concat(activePlanId).concat(encodeURIComponent('&')) + "tab=".concat(servicePageTabs.subscriptionPlans);
    signup(_objectSpread(_objectSpread({}, formData), {}, {
      redirect: redirectPath
    })).then(function (payload) {
      if (payload !== null && payload !== void 0 && payload.email) {
        setAuthStep('confirm-email-dialog');
      }
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SignupFlow, {
      step: authStep,
      email: email,
      onLoginFormSubmit: onLoginFormSubmit,
      onSignupFormSubmit: onSignupFormSubmit,
      setStep: setAuthStep
    }), /*#__PURE__*/_jsx(TWSubscriptionPlanList, _objectSpread(_objectSpread({
      plans: plans,
      onPlanSelect: planSelectHandler
    }, forPosts ? {
      page: SubscriptionPlanListPage.POSTS
    } : {}), {}, {
      planWaitlistIds: planWaitlistIds
    }))]
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    loginRequestSent: state.auth.loginRequestSent,
    user: state.auth.users.current,
    servicePlans: Object.values(state.provider.plans),
    userSubscriptions: Object.values(state.subscriptions.subscriptions),
    accessToken: cookie.get(CookieName.ACCESS_TOKEN),
    resources: state.assets.resources,
    planProspects: state.provider.planProspects,
    currentUser: state.auth.users.current
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    createSubscriptionOrder: function createSubscriptionOrder(planId, redirectURL) {
      return dispatch(createSubscriptionOrderAction({
        planId: planId,
        options: {
          shouldRedirect: true,
          checkoutRedirect: redirectURL
        }
      }));
    },
    createPlanProspect: function createPlanProspect(dto) {
      return dispatch(createPlanProspectAction(dto));
    },
    createServiceProspect: function createServiceProspect(payload) {
      return dispatch(createServiceProspectAction(payload));
    },
    getServicePlans: function getServicePlans(serviceId) {
      return dispatch(_getServicePlans(serviceId));
    },
    getUserSubscriptions: function getUserSubscriptions(userId) {
      return dispatch(_getUserSubscriptions(userId));
    },
    requestLogin: function requestLogin(payload) {
      return dispatch(requestLoginAction(payload, // Don't show "user does not exist" error on login failure
      false));
    },
    signup: function signup(payload) {
      return dispatch(signupAction(payload));
    },
    getPlansForAsset: function getPlansForAsset(payload) {
      return dispatch(getPlansForAssetAction(payload));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanContainer);